<template>
  <div class="invite_friend">
    <div
      class="top_bg"
      :style="{
        'background-image': `url(${bgUrl})`,
      }"
    ></div>
    <div class="content_box content_auto">
      <div class="invite_box">
        <h2>{{ $t('立刻邀请') }}</h2>
        <div class="invite_info">
          <div class="info_box">
            <div class="link_box">
              <p class="me_text">{{ $t('我的邀请链接') }}：</p>
              <p class="link">{{ inviteInfo.myInviteUrl }}</p>
              <el-button type="primary" @click="handleCopy()">
                {{ $t('复制') }}
              </el-button>
            </div>
            <div class="detail">
              <div class="detail-item">
                <p class="key">{{ $t('我的邀请码') }}</p>
                <p class="value">{{ inviteInfo.inviteCode }}</p>
              </div>
              <div class="detail-item">
                <p class="key">{{ $t('邀请人数') }}</p>
                <p class="value">{{ inviteInfo.inviteNum }}</p>
              </div>
              <div class="detail-item">
                <p class="key">{{ $t('我的奖励') }}</p>
                <p class="value">{{ inviteInfo.inviteReward }}</p>
              </div>
            </div>
          </div>
          <div class="QRCode_box">
            <canvas ref="QRCode"></canvas>
          </div>
        </div>
      </div>
      <div class="tab_box">
        <div
          v-for="item in tabs"
          :key="item.value"
          class="tab-item"
          :class="{ active: activeTab === item.value }"
        >
          <span @click="activeTabChangedEvent(item.value)">
            {{ $t(item.label) }}</span
          >
        </div>
      </div>
      <div v-if="activeTab === 'commission'" class="commission-search">
        <CustomSelector
          v-model="commissionType"
          :option-list="[
            { label: '邀请佣金', value: 'inviteCommission' },
            { label: '合伙人佣金', value: 'partnerCommission' },
          ]"
          @input="commissionTypeChangedEvent"
        />
      </div>
      <div
        :style="{
          height: {
            commision: '11px',
            friends: '32px',
          }[activeTab],
        }"
      ></div>
      <div class="table-container">
        <Table
          :columns="columns"
          :data="list"
          :loading="loading"
          :noDataText="`<div class='no_data'>
        <img  src='${require('@/assets/images/no-data.png')}'>
      <span class='text'> ${$t('暂无记录')} </span>
  </div>`"
        >
        </Table>
      </div>
      <div class="page-box">
        <Page
          v-if="total > offset"
          :total="total"
          :page-size="offset"
          :model-value="start"
          show-sizer
          @on-change="pageNoChangeEvent"
          @on-page-size-change="pageSizeChangeEvent"
          @on-prev="pageNoChangeEvent"
          @on-next="pageNoChangeEvent"
        />
      </div>
    </div>
  </div>
</template>
<script>
import qrcode from 'qrcode'
import {
  fetchPartnerRebateList,
  fetchInviteRebateList,
  fetchInviteUserList,
  fetchUserInviteInfo,
} from '@/api/invite'
import { copyText } from '@/utils'
import currentLangType from '@/utils/currentLangType'
import CustomSelector from '../position/components/CustomSelector.vue'

const lang = currentLangType()
export default {
  components: {
    CustomSelector,
  },
  data() {
    return {
      bgUrl: require(`@/assets/images/invite-bg-${
        { zh: 'zh', zh_TW: 'tw', en: 'en' }[lang]
      }.png`),
      inviteInfo: {},
      start: 1,
      offset: 10,
      total: 0,
      list: [],
      loading: true,
      commissionType: 'inviteCommission',
      activeTab: 'commission',
      tabs: [
        { label: '佣金明细', value: 'commission' },
        { label: '邀请好友', value: 'friends' },
      ],
      requestFlag: undefined,
    }
  },
  computed: {
    columns() {
      return {
        commission: [
          { title: this.$t('时间'), key: 'time', align: 'center' },
          { title: this.$t('账号'), key: 'account', align: 'center' },
          { title: this.$t('佣金'), key: 'time', align: 'center' },
        ],
        friends: [
          { title: this.$t('账号'), key: 'account', align: 'center' },
          { title: this.$t('时间'), key: 'time', align: 'center' },
        ],
      }[this.activeTab]
    },
  },
  mounted() {
    this.getUserInviteInfo()
    this.getTableData()
  },
  methods: {
    activeTabChangedEvent(tab) {
      if (tab === 'commission') {
        this.commissionType = 'inviteCommission'
      }
      this.activeTab = tab
      this.start = 1
      this.offset = 10
      this.getTableData()
    },
    commissionTypeChangedEvent() {
      this.start = 1
      this.offset = 10
      this.getTableData()
    },
    pageNoChangeEvent(start) {
      this.start = start
      this.getTableData()
    },
    pageSizeChangeEvent(offset) {
      this.offset = offset
      this.getTableData()
    },
    async getTableData() {
      this.loading = true
      const flag = {
        activeTab: this.activeTab,
        commissionType: this.commissionType,
        offset: this.offset,
        start: this.start,
      }
      this.requestFlag = JSON.stringify(flag)
      const api = {
        friends: fetchInviteUserList,
        commission: {
          inviteCommission: fetchInviteRebateList,
          partnerCommission: fetchPartnerRebateList,
        }[this.commissionType],
      }[this.activeTab]
      const { item, count } = await api({
        offset: this.offset,
        start: this.start - 1,
      })
      if (this.requestFlag !== JSON.stringify(flag)) {
        return
      }
      this.loading = false
      this.list = item
      this.total = count
    },
    handleCopy() {
      copyText(this.inviteInfo.myInviteUrl)
      this.$notify.success({
        title: this.$t('复制成功'),
        duration: 3000,
        offset: 100,
      })
    },
    async getUserInviteInfo() {
      this.inviteInfo = await fetchUserInviteInfo()
      qrcode.toCanvas(this.$refs.QRCode, this.inviteInfo.myInviteUrl, {
        width: 152,
      })
    },
  },
}
</script>
<style lang="less" scoped>
.invite_friend {
  background-color: rgba(255, 255, 255, 1);
  padding-bottom: 40px;
  min-height: 100%;
  .top_bg {
    height: 340px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .content_box {
    .invite_box {
      margin-top: -52px;
      padding: 38px 80px 38px 60px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
      border-radius: 20px;
      background: rgba(255, 255, 255, 1);
      h2 {
        font-size: 24px;
        font-family: PingFangSC-Semibold, 'PingFang SC';
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 33px;
      }
      .invite_info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .info_box {
          margin-top: 18px;
          .link_box {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            .me_text {
              height: 22px;
              line-height: 22px;
            }
            .link {
              margin-right: 17px;
              padding: 8px 10px;
              height: 40px;
              min-width: 600px;
              border-radius: 4px;
              border: 1px solid #979797;
            }
            .element_button_mixin(@padding: 9px 34px);
          }
          .detail {
            margin-top: 30px;
            display: flex;
            &-item {
              width: 160px;
              &:not(:first-child) {
                margin-left: 142px;
              }
              .key {
                height: 20px;
                font-family: PingFangSC-Semibold, 'PingFang SC';
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
                line-height: 20px;
              }
              .value {
                margin-top: 13px;
                height: 38px;
                font-size: 32px;
                font-family: Arial-BoldMT, Arial;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
                line-height: 38px;
              }
            }
          }
        }
        .QRCode_box {
          width: 160px;
          height: 160px;
          border: 4px solid rgba(225, 186, 123, 1);
          border-radius: 4px;
        }
      }
    }
    .tab_box {
      margin-top: 12px;
      height: 54px;
      line-height: 54px;
      display: flex;
      border-bottom: 1px solid #ebebeb;
      .tab-item {
        font-size: 20px;
        font-weight: 500;
        color: rgba(28, 27, 27, 0.5);
        padding: 0 12px;
        &:last-child {
          margin-left: 71px;
        }
        &.active {
          color: #1c1b1b;
          position: relative;
          &::after {
            content: '';
            height: 4px;
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: #1c1b1b;
          }
        }
        span {
          cursor: pointer;
        }
      }
    }
    .commission-search {
      margin-top: 20px;
    }
    .table-container {
      margin-top: 10px;
      .ivu-table-wrapper {
        ::v-deep .ivu-spin-fix {
          // background: rgba(#0a0a0c, 0.8);
          .ivu-spin-dot {
            background-color: #fff;
          }
        }
        ::v-deep .ivu-table {
          background: none;

          &::before {
            content: none;
          }
          .ivu-table-header {
            table {
              height: 40px;
              border-collapse: unset;
            }
            th {
              font-size: 14px;
              font-weight: 400;
              color: #848e9c;
              border: none;
              background: #f9f9fa;
            }
          }
          .ivu-table-body {
            td {
              background: #ffffff;
              font-size: 14px;
              color: #333333;
              border: none;
              padding: 10px 0;
            }
          }
          .ivu-table-tip {
            td {
              background: none;
              border: none;
            }
            span:not(.text) {
              position: relative;
              display: inline-block;
              height: 400px;
              width: 100%;
              .no_data {
                background-color: #ffffff;
                width: 100%;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img {
                  width: 160px;
                  height: 160px;
                  margin-bottom: 10px;
                }
                .text {
                  font-size: 14px;
                  font-weight: 400;
                  color: #969799;
                }
              }
            }
          }
        }
      }
    }
    .page-box {
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>
